import {
  GridCellProps,
  GridColumn as Column,
} from '@progress/kendo-react-grid';
import {
  AdminSubHeaderMainLayout,
  CollapsibleAuditLog,
} from 'Components/Display';
import { AddButton, SmartInputBlock } from 'Components/Form';
import { EditDeleteCell, MainGrid, GridButtonSection } from 'Components/Grid';
import { SecureComponent } from 'Components/Security';
import { FormProvider, GridProvider, useEnums } from 'Context';
import { InputType } from 'Models/FormModels';
import { defaultGridProps } from 'Models/GridModels';
import { Permission } from 'Models/Templates/Permission/Permission';
import { ENDPOINTS } from 'Models/Templates/Routes/Routes';
import { addEditRoute, AddEditSubRoute } from 'Navigation';
import React, { Fragment } from 'react';
import { useGridSearch } from 'Utilities';

class ManagedReviwerSearch {
  searchKey?: string;
}

export const UserManagementManagedReviewers: React.FC = () => {
  const { entityEventType } = useEnums();
  const searchModel = new ManagedReviwerSearch();

  return (
    <AdminSubHeaderMainLayout title="Managed Reviewers">
      <FormProvider formModel={searchModel}>
        <ManagedReviewersFields />
        <GridProvider entityName="Managed Revierwer">
          <ManagedReviewersGrid />
        </GridProvider>
      </FormProvider>
    </AdminSubHeaderMainLayout>
  );
};

const ManagedReviewersFields: React.FC = () => {
  return (
    <div className="mb-3">
      <SmartInputBlock
        name="searchKey"
        label="Search"
        type={InputType.Text}
        placeholder="Username, Name, Email..."
        noPaddingMargin
      />
    </div>
  );
};

const ManagedReviewersGrid: React.FC = () => {
  const [debounceSearchModel, gridToggler] = useGridSearch();

  return (
    <Fragment>
      <SecureComponent permissions={[Permission.AddUser]}>
        <GridButtonSection>
          <AddButton url={addEditRoute(AddEditSubRoute.ManagedReviewer)}>
            New Reviewer Association
          </AddButton>
        </GridButtonSection>
      </SecureComponent>
      <MainGrid
        refreshToggle={gridToggler}
        readEndpoint={ENDPOINTS.managedreviewers.read}
        search={debounceSearchModel}
        {...defaultGridProps}
      >
        <Column field="reviewer.username" title="Username" />
        <Column field="reviewer.firstName" title="First Name" />
        <Column field="reviewer.lastName" title="Last Name" />
        <Column field="doctorAdmin.emailAddress" title="Doctor Admin" />
        <Column field="lastLogin" title="Last Logged In" />
        <Column field="id" title=" " cell={ActionsCell} />
      </MainGrid>
    </Fragment>
  );
};

const ActionsCell: React.FC<GridCellProps> = (props: GridCellProps) => {
  return (
    <EditDeleteCell
      editRoute={addEditRoute(AddEditSubRoute.ManagedReviewer)}
      editPermissions={[Permission.EditUser]}
      deleteEndpoint={ENDPOINTS.managedreviewers.base}
      deletePermissions={[Permission.UnassignedManagedReviewer]}
      {...props}
    />
  );
};
